var $BP_L = 1024;
var $BP_M = 768;
var $BP_S = 480;
var currentWidth = $(window).width();
var activeClass = 'js-active';
function initMenu() {
    var $menuBtn = $('.js-menu-toggle'), $searchBtn = $('.js-search-toggle');
    var $nav = $('.js-nav'), $defaultNav = $('.js-default-nav'), $searchNav = $('.js-search-nav');
    var $header = $('.js-header');
    function toggleMenu() {
        $nav.toggleClass(activeClass);
        $header.toggleClass(activeClass);
    }
    $menuBtn.click(function () {
        $menuBtn.toggleClass(activeClass);
        $defaultNav.addClass(activeClass);
        $searchNav.removeClass(activeClass);
        if ($searchBtn.hasClass(activeClass)) {
            $searchBtn.removeClass(activeClass);
        }
        else {
            toggleMenu();
        }
    });
    $searchBtn.click(function () {
        $searchBtn.toggleClass(activeClass);
        $defaultNav.removeClass(activeClass);
        $searchNav.addClass(activeClass);
        if ($menuBtn.hasClass(activeClass)) {
            $menuBtn.removeClass(activeClass);
        }
        else {
            toggleMenu();
        }
    });
}
function initAccordion() {
    $('.js-accordion').aemAccordion({
        openHash: true
    });
}
function initTab() {
    var $tabWrap = $('.tab-wrap');
    $tabWrap.each(function () {
        var $tabTitle = $(this).find('.tab-category li'), $tabTitlesp = $(this).find('.tab-select'), $tabBody = $(this).find('.tab-list__area'), activeClass = 'active';
        $tabTitle.click(function () {
            var index = $tabTitle.index(this);
            $tabTitle.removeClass(activeClass);
            $(this).addClass(activeClass);
            $tabBody.removeClass(activeClass).eq(index).addClass(activeClass);
        });
        $tabTitlesp.change(function () {
            var indexsp = $tabTitlesp.prop('selectedIndex');
            $tabBody.hide();
            $tabBody.removeClass(activeClass).eq(indexsp).addClass(activeClass).fadeIn();
        });
    });
}
function initInview() {
    $('.js-inview').aemInview({
        scrollEnd: true,
    });
}
var PADDING_RATIO_REGEX = /padding(?:-top)?:\s*[0-9]+(?:\.[0-9]+)?%/;
var PADDING_VALUE_REGEX = /padding(?:-top)?:\s*([0-9]+(?:\.[0-9]+)?)%/;
var WIDTH_ATTR_REGEX = /width="(.*?)"/;
var HEIGHT_ATTR_REGEX = /height="(.*?)"/;
$(function () {
    // $('.aem-post').find('img').wrap('<span class="js-protect"></span>');
    $('.aem-post').find('iframe').each(function () {
        var $iframe = $(this);
        var $parent = $iframe.parent();
        var parentStyle = $parent.attr('style') || '';
        var isWrappedByVideoDiv = parentStyle.includes('position:relative') &&
            parentStyle.includes('padding:') &&
            $parent.children().length === 1 &&
            $parent.children().first().is('iframe');
        var $targetElement = $iframe;
        var targetHtml = $iframe[0].outerHTML;
        if (isWrappedByVideoDiv) {
            $targetElement = $parent;
            targetHtml = $parent[0].outerHTML;
        }
        var isFixedWidth = checkIfFixedWidth(targetHtml);
        var isVertical = checkIfVertical(targetHtml);
        var wrapperClasses = ['movie-wrapper'];
        if (isFixedWidth) {
            wrapperClasses.push('will-responsive-iframe');
        }
        if (isVertical) {
            wrapperClasses.push('is-vertical');
        }
        if (!$targetElement.parent().hasClass('movie-wrapper')) {
            $targetElement.wrap("<div class=\"".concat(wrapperClasses.join(' '), "\"></div>"));
        }
        var src = $iframe.attr('src') || '';
        if (src.indexOf('youtube') !== -1) {
            var $movieWrapper = $targetElement.parent('.movie-wrapper');
            var width = $iframe.attr('width');
            var height = $iframe.attr('height');
            if (width) {
                width = width.toString().replace(/[^0-9]/g, '');
            }
            if (height) {
                height = height.toString().replace(/[^0-9]/g, '');
            }
            if (width && height) {
                $movieWrapper.css('aspect-ratio', width + '/' + height);
                $movieWrapper.css('width', width);
                $movieWrapper.addClass('movie-wrapper--size');
            }
            else if (width) {
                $movieWrapper.css('aspect-ratio', "16 / 9");
                $movieWrapper.css('width', width);
                $movieWrapper.addClass('movie-wrapper--size');
            }
        }
    });
    $('.aem-post').find('table').wrap('<div class="table-wrapper"></div>');
    // $('.js-protect').aemProtectImage({
    //     blankImg: '/images/blank.gif'
    // });
    $('a[href^="#"]').not('.no-scroll').aemSmoothScroll();
    $('[data-fancybox]').fancybox({
        protect: true,
        loop: true,
        toolbar: true,
        smallBtn: false,
        buttons: [
            "close"
        ],
        baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1">' +
            '<div class="fancybox-bg"></div>' +
            '<div class="fancybox-inner">' +
            '<div class="fancybox-infobar"><span class="fancybox-infobar__pagination-current" data-fancybox-index></span><div class="fancybox-infobar__bar"><span class="bar"></span></div><span class="fancybox-infobar__pagination-total" data-fancybox-count></span></div>' +
            '<div class="fancybox-toolbar">{{buttons}}</div>' +
            '<div class="fancybox-navigation">{{arrows}}</div>' +
            '<div class="fancybox-stage"></div>' +
            '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
            '</div>' +
            '</div>',
        afterShow: function (instance, current) {
            $('.fancybox-infobar__bar').each(function () {
                $(this).css('--current', current.index + 1);
                $(this).css('--total', instance.group.length);
            });
        }
    });
    initMenu();
    initAccordion();
    initTab();
    initInview();
});
var $scrollTarget = $('.js-scroll');
var $pagetop = $('.js-pagetop');
var $footer = $('.footer');
$('.select__item').on('change', function () {
    var currentSelect = convertSelect($(this));
});
function convertSelect(currentSelect) {
    if (currentSelect.val()) {
        currentSelect.parents('form').find('#button .button').prop('disabled', false);
    }
    else {
        currentSelect.parents('form').find('#button .button').prop('disabled', true);
    }
}
$(window).on('scroll', function () {
    if ($scrollTarget.length) {
        $scrollTarget.each(function () {
            var storeLinkTopPosition = $(this).offset().top, storeLinkHeight = $(this).innerHeight(), storeLinkBottomPosition = storeLinkTopPosition + storeLinkHeight;
            var footerTopPosition = $footer.offset().top;
            if (storeLinkBottomPosition >= footerTopPosition) {
                $(this).removeClass(activeClass);
            }
            else {
                if ($(window).scrollTop() > 0) {
                    $(this).addClass(activeClass);
                }
                else {
                    $(this).removeClass(activeClass);
                }
            }
        });
    }
    if ($(window).scrollTop() > 0) {
        $pagetop.addClass(activeClass);
    }
    else {
        $pagetop.removeClass(activeClass);
    }
});
$(".js-pagetop").on("click", function () {
    $('html, body').animate({
        scrollTop: 0
    }, 300);
});
$(".submit_form").on("change", function (currentInput) {
    var element = $(this)[0];
    if (element && element.form) {
        submitForm(element.form);
    }
});
function submitForm(currentForm) {
    currentForm.submit();
}
convertSelectMenu();
function convertSelectMenu() {
    var $select = $('.js-select-menu');
    $select.each(function () {
        var _this = $(this);
        var selectedValue;
        var selectedHtml;
        _this.append('<dl class="menu-accordion js-accordion">'
            + '<div>'
            + '<dt class="menu-accordion__title js-accordion-title"></dt>'
            + '<dd class="menu-accordion__body js-accordion-body">'
            + '<span class=\"js-accordion-close\"><span class="js-accordion-close__button">×</span></span>'
            + '<ul class="search-menu"></ul>'
            + '</dd>'
            + '</div>'
            + '</dl>');
        selectedValue = _this.find('option').first().val();
        selectedHtml = _this.find('option[selected]').first().html();
        _this.find('.js-accordion-title').text(selectedHtml);
        if (_this.find('optgroup').length) {
            var firstValue = $(this).find('option').first().val();
            var firstHTML = $(this).find('option').first().html();
            _this.find('.js-accordion-body .search-menu:first').append("<li class=\"search-menu__item\" data-value=\"" + firstValue + "\">\n                        <div class=\"search-menu__inner search-menu__link\"><span>" + firstHTML + "</span></div>\n                    </li>");
            _this.find('optgroup').each(function () {
                var groupFirstValue = $(this).find('option').first().val();
                var groupFirstHTML = $(this).find('option').first().html();
                var list = '';
                $(this).find('option').each(function (index) {
                    if (index !== 0) {
                        var newValue = $(this).val();
                        var newHTML = $(this).html();
                        var is_none = $(this).prop('disabled');
                        if (is_none) {
                            return;
                        }
                        list = list + '<li class="search-menu__item" data-value="' + newValue + '"><div class="search-menu__inner search-menu__link"><span>' + newHTML + '</span></div></li>';
                    }
                });
                _this.find('.js-accordion-body .search-menu:first').append("<li class=\"search-menu__item\" data-value=\"" + groupFirstValue + "\">\n                            <div class=\"search-menu__inner search-menu__link\"><span>" + groupFirstHTML + "</span></div>\n                            <ul class=\"search-menu\">" + list + "</ul>\n                        </li>");
            });
        }
        else {
            _this.find('option').each(function () {
                var newValue = $(this).val();
                var newHTML = $(this).html();
                var is_none = $(this).prop('disabled');
                if (is_none) {
                    return;
                }
                _this.find('.js-accordion-body .search-menu').append('<li class="search-menu__item" data-value="' + newValue + '"><div class="search-menu__inner search-menu__link"><span>' + newHTML + '</span></div></li>');
            });
        }
        _this.find('.search-menu__item').each(function () {
            var selected = $(this).parents('.js-accordion-body').prev('.js-accordion-title').text();
            var value = $(this).text();
            if (selected == value) {
                $(this).addClass('js-selected');
            }
        });
        // _this.find('.search-menu__inner').click(function () {
        //     var newValue = $(this).parent().data('value');
        //     $(this).parents('.js-accordion-body').prev('.js-accordion-title').text($(this).text());
        //     $(this).parents('.js-accordion-body').prev('.js-accordion-title').trigger('click');
        //     _this.find('.search-menu__inner').removeClass('js-selected');
        //     $(this).addClass('js-selected');
        //     _this.find('option[selected]').removeAttr('selected');
        //     _this.find('option[value="' + newValue + '"]').attr('selected', '');
        //     var formElement = $(".submit_form")[0];
        //     if (formElement && formElement.form) {
        //         submitForm(formElement.form);
        //     }
        // });
        _this.find('.search-menu__inner').click(function () {
          var newValue = $(this).parent().data('value');

          $(this).parents('.js-accordion-body').prev('.js-accordion-title').text($.trim($(this).text()));
          $(this).parents('.js-accordion-body').prev('.js-accordion-title').trigger('click');

          _this.find('.search-menu__item').removeClass('js-selected');
          $(this).parent().addClass('js-selected');

          _this.find('option').prop('selected', false);
          _this.find('option[value="' + newValue + '"]').prop('selected', true);

          if (newValue) {
            window.location.href = newValue;
        }
      });
    });
}
$(".js-accordion-close").on("click", function () {
    closeSearchAccordion();
});
$(".js-search-toggle").on("click", function () {
    closeSearchAccordion();
});
function closeSearchAccordion() {
    $(".js-accordion-title,.js-accordion-body").removeClass('js-open');
    $(".js-accordion-body").removeAttr('style');
}
function checkIfFixedWidth(targetHtml) {
    var hasPaddingRatio = !!targetHtml.match(PADDING_RATIO_REGEX);
    if (hasPaddingRatio) {
        return false;
    }
    var hasWidthAndHeight = targetHtml.match(WIDTH_ATTR_REGEX) && targetHtml.match(HEIGHT_ATTR_REGEX);
    var noPadding = !targetHtml.match(/padding(?:-top)?/);
    return !!hasWidthAndHeight || noPadding;
}
function checkIfVertical(targetHtml) {
    var paddingMatch = targetHtml.match(PADDING_VALUE_REGEX);
    if (paddingMatch && parseFloat(paddingMatch[1]) >= 100) {
        return true;
    }
    return false;
}

//# sourceMappingURL=main.js.map